import type { BandArrangement } from '@/audio/useBandArrangement';

/** Playback position uses the performed form, which can be longer than the written score. */
export function bandPlaybackStatus({
  playingIndex,
  playedBars,
  preExpanded,
  flat,
}: Pick<BandArrangement, 'playingIndex' | 'playedBars' | 'preExpanded' | 'flat'>): string {
  if (playingIndex >= 0) return `Bar ${playingIndex + 1}/${playedBars}`;
  if (preExpanded && playedBars !== flat.length) {
    return `${flat.length} bars · plays ${playedBars}`;
  }
  return `${flat.length} bar${flat.length === 1 ? '' : 's'}`;
}
